import {
    Solicitation,
    SolicitationClient,
    SolicitationClientInsertDTO, SolicitationMailInsertDTO, SolicitationOperationViewDetail, WorkflowSolicitationDTO
} from "../../types/solicitation/solicitationData";
import {HttpAxiosRequest} from "../httpAxiosBase";
import {ClientMail, ClientRelationshipInsert} from "../../types/client/clientData";
import {EntityListWithPagination, EntityWithIdFields} from "src/types/baseEntities";
import {FilterSolicitationSearch} from "../../types/solicitation/solicitationFilter";
import {ActivitySolicitation} from "../../types/activity/activityData";


export const HttpSolicitation = {
    getEndpoint: (url: string): string => `solicitud${url}`,

    insert: (solicitation: SolicitationClientInsertDTO) : Promise<number> => {
        return HttpAxiosRequest.post(HttpSolicitation.getEndpoint(""),
            solicitation)
    },
    
    insertWorkflow: (solicitationId: number, solicitationPost: WorkflowSolicitationDTO) : Promise<number> => {
      return HttpAxiosRequest.post(
          HttpSolicitation.getEndpoint(`/${solicitationId}/enviar`),
          {...solicitationPost,
              codModulo: 1
          }
      )  
    },

    update: (solicitation: SolicitationClientInsertDTO) : Promise<number> => {
        return HttpAxiosRequest.put(HttpSolicitation.getEndpoint(`/${solicitation[EntityWithIdFields.Id]}`),
            solicitation)
    },
    
    getSolicitations: (filterSolicitationSearch: FilterSolicitationSearch) : Promise<EntityListWithPagination<Solicitation>> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(
            HttpSolicitation.getEndpoint(""),
            filterSolicitationSearch
        );
    },
    
    getClientRelatedsByIdSolicitation: (intIdSolicitation: number) : Promise<SolicitationClient[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitation.getEndpoint(`/${intIdSolicitation}/relacionados`)
        );
    },

    getSolicitationById: (intIdSolicitation: number) : Promise<Solicitation> => {
        return HttpAxiosRequest.get(
            HttpSolicitation.getEndpoint(`/${intIdSolicitation}`)
        );
    },

    getClientMailsByIdSolicitation: (intIdSolicitation: number) : Promise<ClientMail[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitation.getEndpoint(`/${intIdSolicitation}/mails`)
        );
    },

    insertClientMailByIdSolicitation: (intIdSolicitation: number, mail: SolicitationMailInsertDTO) : Promise<number> => {
        return HttpAxiosRequest.post(
            HttpSolicitation.getEndpoint(`/${intIdSolicitation}/mails`),
            mail
        );
    },
}


export const HttpSolicitationClient = {
    getEndpoint: (url: string, idSolicitud: number): string => `solicitud/${idSolicitud}/relacionados${url}`,
    
    insertClientRelated: (intIdSolicitation: number, clientId: number, clientCUIT: string, clientBusinessName: string, relationships: ClientRelationshipInsert[]): Promise<ClientRelationshipInsert[]> => {
        return HttpAxiosRequest.post(
            HttpSolicitationClient.getEndpoint('', intIdSolicitation),
            {
                idCliente: clientId,
                razonSocial: clientBusinessName,
                cuit: clientCUIT,
                lstRelaciones: relationships
            }
        );
    },

    deleteClientRelated: (intIdSolicitation: number, idClienteRelacionado: number): Promise<string> => {
        return HttpAxiosRequest.delete(
            HttpSolicitationClient.getEndpoint(`/${idClienteRelacionado}`, intIdSolicitation)
        );
    },
    
}

export const HttpSolicitationActivities = {
    getEndpoint: (url: string): string => `solicitud/actividad${url}`,

    getActivitiesByIdSolicitation: (intIdSolicitation: number) : Promise<ActivitySolicitation[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitationActivities.getEndpoint(`/${intIdSolicitation}`)
        );
    },

    insert: (activitySolicitation: ActivitySolicitation): Promise<number> => {
        return HttpAxiosRequest.post(
            HttpSolicitationActivities.getEndpoint(""),
            activitySolicitation
        );
    },
}


export const HttpSolicitationOperations = {
    getEndpoint: (intIdSolicitation: number, url: string): string => `solicitud/${intIdSolicitation}/operaciones${url}`,


    getOperationsBySolicitationId: (intIdSolicitation: number): Promise<SolicitationOperationViewDetail[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitationOperations.getEndpoint(intIdSolicitation, "")
        );
    },
}